module.exports = __webpack_public_path__ + "static/media/ewm-right.03e6f7bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newPeople/ewm-right.png
// module id = 2056
// module chunks = 6